import api from "./Api";

class BoletoReceberService {
  GetBoletoReceber(payload) {
    return api.get("/v1/boletoReceber/" + payload).then((response) => {
      return response.data;
    });
  }

  GetBoletoReceberOData(payload) {
    return api.get("/OData/BoletoReceber" + payload).then((response) => {
      return response.data;
    });
  }

  PostMovimentacaoApi(payload) {
    const { idAgenciaBoleto, dataInicial, dataFinal } = payload;
    return api
      .post(
        `/v1/BoletoReceber/MovimentacaoApi/${idAgenciaBoleto}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`
      )
      .then((response) => {
        return response.data;
      });
  }

  PostPreviaRetornoCnab(payload) {
    const { idAgenciaBoleto, formData } = payload;
    return api
      .post(
        `/v1/BoletoReceber/RetornoCnab/Previa/${idAgenciaBoleto}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  PostConfirmarRetornoCnab(payload) {
    return api
      .post(`/v1/BoletoReceber/RetornoCnab/Confirmar`, payload)
      .then((response) => {
        return response.data;
      });
  }

  PostGerarRemessa(payload) {
    return api
      .post(`/v1/BoletoReceber/Remessa/Gerar`, payload)
      .then((response) => {
        return response.data;
      });
  }

  GetBoletoRemessaOData(payload) {
    return api.get("/OData/BoletoRemessa" + payload).then((response) => {
      return response.data;
    });
  }

  DownloadRemessaArquivo(payload) {
    return api.get(`/v1/BoletoRemessa/Arquivo/${payload}`, {
      responseType: "blob",
    });
  }
}

export default new BoletoReceberService();
